import { createAction, props } from '@ngrx/store';
import type { RichTextField } from '@sitecore-jss/sitecore-jss-angular';

export const initOrderCustomerType = createAction(
  '[become-a-customer-order] Init customer type'
);

export const orderCustomerTypeEnabled = createAction(
  '[become-a-customer-order] Enable customer type',
  props<{ enabled: boolean }>()
);

export const showCustomerTypeExplanation = createAction(
  '[become-a-customer-order] Show customer type explanation',
  props<{
    payload: {
      customerTypeModalTitle: string;
      customerTypeModalBody: RichTextField;
      customerTypeModalButtonText: string;
    };
  }>()
);
